import { useContext } from 'react';
import { EventJobRunningContext } from '../contexts/EventJobRunningContext';

export const useEventJobRunning = (): boolean => {
  return useContext(EventJobRunningContext);
};
